import {AssetFinanceTier2} from '../admin-service.domain';

export type AssetTier2Value = AssetFinanceTier2 | null;
